query GetInvitationByToken(
  $baseSiteId: BaseSiteId!
  $invitationToken: String!
  $division: String
  $distributionChannel: String
) {
  getInvitationByToken(
    baseSiteId: $baseSiteId
    invitationToken: $invitationToken
    division: $division
    distributionChannel: $distributionChannel
  ) {
    invitationEmail
  }
}
